/**
 * ThemeRoot (1.36.0)
 *
 * Оборачивает приложение и обеспечивает мгновенное переключение тем.
 *
 * Зачем нужен key-ремоунт:
 *   токены `C` читаются во время рендера (Proxy → активная палитра). React сам
 *   по себе не знает, что значения «изменились» при смене темы, потому что
 *   меняется внешняя переменная, а не пропсы/стейт компонентов. Самый надёжный
 *   способ гарантированно перекрасить ВСЁ дерево (включая глубоко вложенные
 *   инлайн-стили) — перемонтировать его сменой `key`.
 *
 *   Смена темы — редкое действие пользователя. Кратковременный ремоунт не
 *   приводит к потере данных: всё состояние живёт в zustand-сторах и IndexedDB,
 *   а не в локальном стейте экранов. Поэтому это безопасный компромисс.
 *
 *   data-theme на <html> ставится синхронно в сторе (см. tokens.ts), что
 *   позволяет глобальному CSS (GlobalCSS) красить body/скроллбары до ремоунта.
 */

import { type ReactNode } from 'react';
import { useThemeStore } from './tokens';

export function ThemeRoot({ children }: { children: ReactNode }) {
  const theme = useThemeStore((s) => s.theme);
  return <div key={theme} style={{ height: '100%' }}>{children}</div>;
}
